var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "circular",
    viewBox: "25 25 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path-outline",
    cx: 50,
    cy: 50,
    r: 20,
    fill: "none",
    strokeWidth: 1,
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: 50,
    cy: 50,
    r: 20,
    fill: "none",
    strokeWidth: 1,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoader);
export default __webpack_public_path__ + "static/media/icon-loader.a8681ff2ffb042715c197b515de3c37c.svg";
export { ForwardRef as ReactComponent };